import { type ReactNode } from 'react';

import styles from './Badge.module.css';

export const MAX_BADGES = 2; // We should show only 2 badges for Pairings / Products
export const MAX_BADGES_FOR_YOU = 1;

export enum BadgeVariant {
  New = 'New',
  NewAlt = 'NewAlt',
  Misc = 'Misc',
  OnTheWay = 'OnTheWay',
  InYourCart = 'InYourCart',
  Skipped = 'Skipped',
  Delivered = 'Delivered',
  Incomplete = 'Incomplete',
  ComingUp = 'ComingUp',
}

interface Props {
  testid?: string;
  children: ReactNode;
  className?: string;
  variant?: BadgeVariant;
}

const getClassNamesForVariant = (variant?: BadgeVariant) => {
  switch (variant) {
    case BadgeVariant.New:
      return styles['new'];
    case BadgeVariant.NewAlt:
      return styles['new-alt'];
    case BadgeVariant.Misc:
      return styles['misc'];
    case BadgeVariant.OnTheWay:
      return styles['on-the-way'];
    case BadgeVariant.InYourCart:
      return styles['in-your-cart'];
    case BadgeVariant.Skipped:
      return styles['skipped'];
    case BadgeVariant.Delivered:
      return styles['delivered'];
    case BadgeVariant.Incomplete:
      return styles['incomplete'];
    case BadgeVariant.ComingUp:
      return styles['coming-up'];
  }
  return '';
};

export function Badge(props: Props) {
  const { testid, children, variant, className } = props;

  return (
    <div
      data-testid={testid}
      className={`${styles.container} ${getClassNamesForVariant(
        variant
      )} ${className}`}
    >
      {children}
    </div>
  );
}
